import { render, staticRenderFns } from "./LocationUlsanPage.vue?vue&type=template&id=3a58663a&scoped=true&"
import script from "./LocationUlsanPage.vue?vue&type=script&lang=js&"
export * from "./LocationUlsanPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a58663a",
  null
  
)

export default component.exports